


  export const mapCustDutyResponseToForm = (data) => {
    if (!data) return {};
  
    return {
      // ✅ ROW 1
      cthhs: data?.custDutyCTHorHSNNo,
      hscode: data?.custDutyCTHorHSNNo?.name,
      declaration: "",
      singlewindow: data?.custDutySingleWindowInfoRequired,

      // ✅ ROW 2
      ritcno: data?.custDutyRITCNo,
      ritcnoratetype: data?.custDutyRateType,
  
      // ✅ ROW 3 - BASIC DUTY
      basicdutysrNo: data?.custDutyBasicDuty?.srNo,
      basicnotn: data?.custDutyBasicDuty?.notn,    
      basicdutypercentage: data?.custDutyBasicDuty?.percentage,
      basicdutymethod: data?.custDutyBasicDuty?.method,
      basicdutyvalue: data?.custDutyBasicDuty?.value,
      basicdutyunit: data?.custDutyBasicDuty?.unit,


      // ✅ ROW 4 - AIDC
      aidcsrNo: data?.custDutyAIDC?.srNo,
      aidcnotn: data?.custDutyAIDC?.notn,
      aidcpercentage: data?.custDutyAIDC?.percentage,
      aidcextemtion: data?.custDutyAIDC?.extemtion,
      aidcextemtionNotn: data?.custDutyAIDC?.extemtionNotn,
      aidcvalue: data?.custDutyAIDC?.value,

      // ✅ ROW 5 - HEALTH CESS
      HealthCesssrNo: data?.custDutyHealthCess?.srNo,
      HealthCesssnotn: data?.custDutyHealthCess?.notn,
      HealthCessspercentage: data?.custDutyHealthCess?.percentage,
      HealthCesssmethod: data?.custDutyHealthCess?.method,
      healthvalue: data?.custDutyHealthCess?.value,
      healthunit: data?.custDutyHealthCess?.unit,
 
      // ✅ ROW 6 - ROAD INFRA
      RoadInfrasrNo: data?.custDutyRoadInfraCess?.srNo,
      RoadInfranotn: data?.custDutyRoadInfraCess?.notn,
      RoadInfrapercentage: data?.custDutyRoadInfraCess?.percentage,
      RoadInframethod: data?.custDutyRoadInfraCess?.method,
      RoadInfravalue: data?.custDutyRoadInfraCess?.value,
      RoadInfraunit: data?.custDutyRoadInfraCess?.unit,

      // ✅ ROW 7 - SOCIAL WELFARE
      SocialWelfaresrNo: data?.custDutySocialWelfareSurch?.srNo,
      SocialWelfarenotn: data?.custDutySocialWelfareSurch?.notn,
      SocialWelfarepercentage: data?.custDutySocialWelfareSurch?.percentage,
  

      // ✅ ROW 8 - EDUCATION
      EducationCesssrNo: data?.custDutyEducationCess?.srNo,
      EducationCessnotn: data?.custDutyEducationCess?.notn,
      EducationCesspercentage: data?.custDutyEducationCess?.percentage,
  
      // ✅ ROW 9 - SEC & HIGHER ED
      SecHigherEdCesssrNo: data?.custDutySecHrEdCess?.srNo,
      SecHigherEdCessnotn: data?.custDutySecHrEdCess?.notn,
      SecHigherEdCesspercentage: data?.custDutySecHrEdCess?.percentage,

      // ✅ ROW 10 - NCD
      NCDsrNo: data?.custDutyNCD?.srNo,
      NCDnotn: data?.custDutyNCD?.notn,
      NCDpercentage: data?.custDutyNCD?.percentage,
      NCDmethod: data?.custDutyNCD?.method,
      NCDvalue: data?.custDutyNCD?.value,
      NCDunit: data?.custDutyNCD?.unit,

      // ✅ ROW 11 - AGGREGATE
      AggregateDutysrNo: data?.custDutyAggregateDuty?.srNo,
      AggregateDutynotn: data?.custDutyAggregateDuty?.notn,
      AggregateDutypercentage: data?.custDutyAggregateDuty?.percentage,

      // ✅ ROW 12 - SAFEGUARD
      SafeguardDutysrNo: data?.custDutySafeGuardDuty?.srNo,
      SafeguardDutynotn: data?.custDutySafeGuardDuty?.notn,
      SafeguardDutypercentage: data?.custDutySafeGuardDuty?.percentage,
      SafeguardDutymethod: data?.custDutySafeGuardDuty?.method,
      SafeguardDutyvalue: data?.custDutySafeGuardDuty?.value,
      SafeguardDutyunit: data?.custDutySafeGuardDuty?.unit,

      // ✅ ROW 13 - SAPTA
      SAPTANotnsrNo: data?.custDutySaptaNotn?.srNo,
      SAPTANotnnotn: data?.custDutySaptaNotn?.notn,
      SAPTANotnpercentage: data?.custDutySaptaNotn?.percentage,

      // ✅ ROW 14 - TARIFF
      TariffValuresrNo: data?.custDutyTarriffValue?.srNo,
      TariffValuenotn: data?.custDutyTarriffValue?.notn,
      TariffValuequantity: data?.custDutyTarriffValue?.quantity,
      amountType: data?.custDutyTarriffValue?.amountType,
      Tariff121Value: data?.custDutyTarriffValue?.amountValue,

    };
  };


  export const mapCustDutyFormToRequest = (formData) => {
    if (!formData) return {};
  
    return {
      custDutyCTHorHSNNo: formData?.cthhs,
      custDutyRITCNo: formData?.ritcno,
      custDutyRateType: formData?.ritcnoratetype,
      custDutySingleWindowInfoRequired: formData?.singlewindow,
  
      // ✅ BASIC DUTY
      custDutyBasicDuty: {
        srNo: formData?.basicdutysrNo,
        notn: formData?.basicnotn,
        percentage: formData?.basicdutypercentage,
        method: formData?.basicdutymethod,
        value: formData?.basicdutyvalue,
        unit: formData?.basicdutyunit,
      },
  
      // ✅ AIDC
      custDutyAIDC: {
        srNo: formData?.aidcsrNo,
        notn: formData?.aidcnotn,
        percentage: formData?.aidcpercentage,
        extemtion: formData?.aidcextemtion,
        extemtionNotn: formData?.aidcextemtionNotn,
        value: formData?.aidcvalue,
      },
  
      // ✅ HEALTH CESS
      custDutyHealthCess: {
        srNo: formData?.HealthCesssrNo,
        notn: formData?.HealthCesssnotn,
        percentage: formData?.HealthCessspercentage,
        method: formData?.HealthCesssmethod,
        value: formData?.healthvalue,
        unit: formData?.healthunit,
      },
  
      // ✅ ROAD INFRA
      custDutyRoadInfraCess: {
        srNo: formData?.RoadInfrasrNo,
        notn: formData?.RoadInfranotn,
        percentage: formData?.RoadInfrapercentage,
        method: formData?.RoadInframethod,
        value: formData?.RoadInfravalue,
        unit: formData?.RoadInfraunit,
      },
  
      // ✅ SOCIAL WELFARE
      custDutySocialWelfareSurch: {
        srNo: formData?.SocialWelfaresrNo,
        notn: formData?.SocialWelfarenotn,
        percentage: formData?.SocialWelfarepercentage,
      },
  
      // ✅ EDUCATION
      custDutyEducationCess: {
        srNo: formData?.EducationCesssrNo,
        notn: formData?.EducationCessnotn,
        percentage: formData?.EducationCesspercentage,
      },
  
      // ✅ SEC & HIGHER ED
      custDutySecHrEdCess: {
        srNo: formData?.SecHigherEdCesssrNo,
        notn: formData?.SecHigherEdCessnotn,
        percentage: formData?.SecHigherEdCesspercentage,
      },
  
      // ✅ NCD
      custDutyNCD: {
        srNo: formData?.NCDsrNo,
        notn: formData?.NCDnotn,
        percentage: formData?.NCDpercentage,
        method: formData?.NCDmethod,
        value: formData?.NCDvalue,
        unit: formData?.NCDunit,
      },
  
      // ✅ AGGREGATE
      custDutyAggregateDuty: {
        srNo: formData?.AggregateDutysrNo,
        notn: formData?.AggregateDutynotn,
        percentage: formData?.AggregateDutypercentage,
      },
  
      // ✅ SAFEGUARD
      custDutySafeGuardDuty: {
        srNo: formData?.SafeguardDutysrNo,
        notn: formData?.SafeguardDutynotn,
        percentage: formData?.SafeguardDutypercentage,
        method: formData?.SafeguardDutymethod,
        value: formData?.SafeguardDutyvalue,
        unit: formData?.SafeguardDutyunit,
      },
  
      // ✅ SAPTA
      custDutySaptaNotn: {
        srNo: formData?.SAPTANotnsrNo,
        notn: formData?.SAPTANotnnotn,
        text: formData?.SAPTANotnpercentage, // UI la text inga irundha inga pogum
      },
  
      // ✅ TARIFF
      custDutyTarriffValue: {
        srNo: formData?.TariffValuresrNo,
        notn: formData?.TariffValuenotn,
        quantity: formData?.TariffValuequantity,
        amountType: formData?.amountType,
        amountValue: formData?.Tariff121Value,
      },
    };
  };
  

export const mapImportGSTResponseToForm = (raw) => {
  console.log("🔵 Raw GST data received for mapping:", raw);

  // 🟢 FIX: If array → pick first element
  const rawData = Array.isArray(raw) ? raw[0] : raw;

  // 🟢 FIX: If wrapped in {data:{}} → unwrap it
  const data = rawData?.data ? rawData.data : rawData;

  console.log("🟢 Normalized GST data used for mapping:", data);

  if (!data) {
    console.warn("❌ No GST data found!");
    return {};
  }

  const mapped = {
    issuesrnotification: data.notification || "",
    issuessrNo: data.srNo?.id || "",
    issuePriceValue: data.issuePriceValue ?? 0,
    issuePriceQuantity: data.issuePriceQuantity?.id || "",

    dutyNotation: data.igst?.dutyNotation || "",
    dutySrNo: data.igst?.dutySrNo?.id || "",
    dutyPercentage: data.igst?.dutyPercentage ?? 0,
    dutyLevel: data.igst?.dutyLevel || "Plus",
    dutyValue: data.igst?.dutyValue ?? 0,
    dutyQuantity: data.igst?.dutyQuantity ?? 0,
    dutyQuantityValue: data.igst?.dutyQuantityValue?.id || "",
    exemptionType: data.igst?.exemptionType || "",
    exemptionNotation: data.igst?.exemptionNotation || "",
    exemptionSrNo: data.igst?.exemptionSrNo?.id || "",
    exemptionPercentage: data.igst?.exemptionPercentage ?? 0,
    exemptionLevel: data.igst?.exemptionLevel || "Plus",
    exemptionValue: data.igst?.exemptionValue ?? 0,
    exemptionQuantityValue: data.igst?.exemptionQuantityValue?.id || "",
    exemptionEffectiveDuty: data.igst?.exemptionEffectiveDuty ?? 0,

    cessdutyNotation: data.cess?.dutyNotation || "",
    cessdutySrNo: data.cess?.dutySrNo?.id || "",
    cessdutyPercentage: data.cess?.dutyPercentage ?? 0,
    cessdutyLevel: data.cess?.dutyLevel || "Plus",
    cessdutyValue: data.cess?.dutyValue ?? 0,
    cessdutyQuantity: data.cess?.dutyQuantity ?? 0,
    cessdutyQuantityValue: data.cess?.dutyQuantityValue?.id || "",
    cessexemptionType: data.cess?.exemptionType || "",
    cessexemptionNotation: data.cess?.exemptionNotation || "",
    cessexemptionSrNo: data.cess?.exemptionSrNo?.id || "",
    cessexemptionPercentage: data.cess?.exemptionPercentage ?? 0,
    cessexemptionLevel: data.cess?.exemptionLevel || "Plus",
    cessexemptionValue: data.cess?.exemptionValue ?? 0,
    cessexemptionQuantityValue: data.cess?.exemptionQuantityValue?.id || "",
    cessexemptionEffectiveDuty: data.cess?.exemptionEffectiveDuty ?? 0,
  };

  console.log("🟩 FINAL MAPPED GST FORM DATA:", mapped);

  return mapped;
};


// Remove empty values helper
const clean = (obj) => {
  if (!obj || typeof obj !== "object") return obj;

  const cleaned = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(typeof value === "number" && isNaN(value))
    ) {
      cleaned[key] = value;
    }
  });

  return cleaned;
};

export const mapGSTFormToRequest = (form) => {
  const gst = {
    notification: form.issuesrnotification,
    srNo: form.issuessrNo,

    issuePriceValue: form.issuePriceValue,
    issuePriceQuantity: form.issuePriceQuantity,

    igst: clean({
      dutySrNo: form.dutySrNo,
      dutyPercentage: Number(form.dutyPercentage),
      dutyLevel: form.dutyLevel,
      dutyValue: Number(form.dutyValue),

      dutyQuantity: Number(form.dutyQuantity),
      dutyQuantityValue: form.dutyQuantityValue,
      dutyNotation: form.dutyNotation,

      exemptionType: form.exemptionType,
      exemptionNotation: form.exemptionNotation,
      exemptionSrNo: form.exemptionSrNo,
      exemptionPercentage: Number(form.exemptionPercentage),
      exemptionLevel: form.exemptionLevel,
      exemptionQuantityValue: form.exemptionQuantityValue,
      exemptionValue: Number(form.exemptionValue),
      exemptionEffectiveDuty: Number(form.exemptionEffectiveDuty),
    }),

    cess: clean({
      dutySrNo: form.cessdutySrNo,
      dutyPercentage: Number(form.cessdutyPercentage),
      dutyLevel: form.cessdutyLevel,
      dutyValue: Number(form.cessdutyValue),

      dutyQuantity: Number(form.cessdutyQuantity),
      dutyQuantityValue: form.cessdutyQuantityValue,
      dutyNotation: form.cessdutyNotation,

      exemptionType: form.cessexemptionType,
      exemptionNotation: form.cessexemptionNotation,
      exemptionSrNo: form.cessexemptionSrNo,
      exemptionPercentage: Number(form.cessexemptionPercentage),
      exemptionLevel: form.cessexemptionLevel,
      exemptionQuantityValue: form.cessexemptionQuantityValue,
      exemptionValue: Number(form.cessexemptionValue),
      exemptionEffectiveDuty: Number(form.cessexemptionEffectiveDuty),
    }),
  };

  return { gst: clean(gst) };
};



